// import react from 'react'
import ErrorPage from './components/errorPage';
import Home from './components/home';
import Rooms from './components/rooms';
import SingleRoom from './components/singleRoom';
import {Routes, Route} from 'react-router-dom'
import NavBar from './components/navBar';
import {useParams} from 'react-router-dom'
import React from 'react';
function App() {
  const params = useParams()
  return (
    <React.Fragment params={params}>
      <NavBar />
      <Routes>
        <Route 
        path='/' exact element={<>
          <Home />
        </>}
        /> 
     
        <Route 
        path='/rooms'  element={<>
           <Rooms />
        </>}
        /> 

        <Route 
        path='/rooms/slug'  element={<>
          <SingleRoom />
        </>}
        /> 

        <Route 
          path='*' element={<>
          <ErrorPage />
        </>}
        /> 
      </Routes>
      
    </React.Fragment>
  );
}

export default App;
